// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[dir] .create-company-modal .wizard-card-footer,[dir] .create-company-modal .wizard-tab-content{box-shadow:none}[dir] .create-company-modal .input-group-merge .input-group-text{padding:0}", ""]);
// Exports
module.exports = exports;
